// extracted by mini-css-extract-plugin
module.exports = {"SelectedRowCard":"SelectedRowCard_SelectedRowCard__3JoRI","Itinerary":"SelectedRowCard_Itinerary__3kI-r"};